import { getCurrentDomain } from '../../../shared/utils/host';

import categories from './categories';
import language from './language';

/**
 * All config. options available here:
 * https://cookieconsent.orestbida.com/reference/configuration-reference.html
 */
const config = {
  cookie: {
    domain: `.${getCurrentDomain()}`,
    path: '/',
    expiresAfterDays: 365,
  },
  categories,
  language,
  revision: 2,
  outdatedCookies: [{ name: /^ma_/, domain: `.${getCurrentDomain()}` }],
};

export default config;
